import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { Button, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import * as React from "react";
import { RotationPackEntry, RotationPackItem } from "./entry";

interface RotationPackProps {
    list: RotationPackItem[];
    classes: any;

    onAdd();

    onUpdate(item: RotationPackItem);

    onRemove(item: RotationPackItem);
}

export class RotationPacks extends React.Component<RotationPackProps> {
    render() {
        if (!this.props.list.length) {
            return <Paper elevation={0}>
                <div className="no-items-placeholder">
                    <NotInterestedIcon/>
                    <h3>No Rotation Packs found</h3>
                </div>
            </Paper>;
        }

        const {classes} = this.props;

        return <Paper elevation={0}>
            <div>
                <Table className="min-table-size">
                    <TableHead>
                        <TableRow>
                            <TableCell>Package ID</TableCell>
                            <TableCell>Title</TableCell>
                            <TableCell>Subtitle</TableCell>
                            <TableCell>Category</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>Available at (endOf)</TableCell>
                            <TableCell>Bonus (%)</TableCell>
                            <TableCell>Validate Payment?</TableCell>
                            <TableCell style={{width: 180}}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.props.list.map(item =>
                            <RotationPackEntry key={item.id} entry={item} classes={classes}
                                               onRemove={this.props.onRemove}
                                               onUpdate={this.props.onUpdate}/>)}
                    </TableBody>
                </Table>
            </div>

            <div style={{padding: 20}}>
                <Button disableElevation variant={"contained"} color={"primary"} onClick={this.props.onAdd}>
                    Add
                </Button>
            </div>
        </Paper>;
    }
}
